import { BriefType } from "../../../constants/types";
import { PAGES } from "./pages.constant";
import { TResourceType } from "../../../types/resources/resources.types";
import { Nullable } from "../../../types/common";
import { resourcePathsMap } from "../../../types/resources/resources.maps";
import { getResourceBasicType } from "../../../types/resources/resources.functions";
import { useEffect } from "react";

export const getBriefPageUrl = (briefType: BriefType): string => {
  switch (briefType) {
    case BriefType.CAMPAIGN_BRIEF:
      return PAGES.CAMPAIGN_BRIEF.URL;
    case BriefType.EXECUTION_BRIEF:
      return PAGES.EXECUTION_BRIEF.URL;
    case BriefType.WORK_ORDER:
      return PAGES.WORK_ORDER.URL;
  }
};

export const getResourceLink = (
  resourceId: number,
  resourceType: TResourceType
): Nullable<string> => {
  const basicType = getResourceBasicType(resourceType);
  if (resourceId && basicType) {
    return `${resourcePathsMap[basicType]}/${resourceId}`;
  }

  return null;
};

export const getIdPath = (path: string): string => `${path}/:id`;

export const usePageTitle = (title: string, override?: boolean) => {
  useEffect(() => {
    const prevTitle = document.title;
    if (override) document.title = title;
    else document.title = `${PAGES.ROOT.TITLE} - ${title}`;
    return () => {
      document.title = prevTitle;
    };
  });
};
